import Button from "components/buttons/Button";
import LinkButton from "components/buttons/LinkButton";
import { authService } from "myfirebase";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Home = ({ isLoggedIn }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  document.title = "Home | Atrable";

  const dropdownbuttonstyle = {
    //css style here
  };

  const signOut = () => {
    authService
      .signOut()
      .then(() => {
        alert("Successfully signed out");
      })
      .catch((error) => {
        alert(error.message);
      });
  };

  return (
    <div style={{ minHeight: "100vh", textAlign: "center" }}>
      <div style={{ height: 30 }} />
      {isLoggedIn ? (
        <>
          <Button
            backgroundColor="#1877f3"
            color="white"
            width="calc(90% + 30px)"
            maxWidth="750px"
            minWidth="100px"
            onClick={signOut}
            zoom
          >
            Sign Out
          </Button>
          <div style={{ height: "30px" }} />
        </>
      ) : (
        <>
          <LinkButton
            linkTo="/auth"
            backgroundColor="#1877f3"
            color="white"
            width="calc(90% + 30px)"
            maxWidth="750px"
            minWidth="100px"
            zoom
          >
            Create Account or Sign In
          </LinkButton>
          <h2>Suggested posts here</h2>
        </>
      )}
    </div>
  );
};
export default Home;
